import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useMemo, useState } from "react";
import { handleGetPass } from "../Share/Func/Storage";
import { CallGameAddKnb } from "../Api/Enforcement";
import { SwalError, SwalFail, SwalSuccess } from "../Share/Swal";

export const useAddKNBForm = ({ user, handleCloseKnbModal }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const addKNBSchema = yup.object().shape({
    knb: yup
      .number()
      .typeError("KNB không đúng định dạng")
      .required("Vui lòng nhập KNB")
      .test("is-valid-knb", "Tổng KNB phải lớn hơn 0", function (value) {
        return value + user.Knb >= 0;
      }),
    knbKhoa: yup
      .number()
      .typeError("KNB Khóa không đúng định dạng")
      .required("Vui lòng nhập KNB Khóa")
      .test("is-valid-knb", "Tổng KNB Khóa phải lớn hơn 0", function (value) {
        return value + user.KnbKhoa >= 0;
      }),
  });

  const { control, handleSubmit } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
    defaultValues: useMemo(
      () => ({
        receiverName: user.AccountName,
        knb: 0,
        knbKhoa: 0,
        type: "PAY",
        secPassword: handleGetPass(),
      }),
      [user]
    ),
    resolver: yupResolver(addKNBSchema),
  });

  const handleAddKnb = (formData) => {
    if (isSubmitting) return;
    setIsSubmitting(true);
    CallGameAddKnb(formData, (res) => {
      setIsSubmitting(false);
      if (!res.Status) {
        if (res !== "Successfully")
          return SwalError("Cập nhật thất bại! \nLiên hệ để được hỗ trợ");
        else {
          SwalSuccess("cập nhật thành công!");
          handleCloseKnbModal();
        }
      } else {
        var error = res.Status;
        if (error.status === 400) SwalFail(error.data.Message);
        else SwalError("Cập nhật thất bại! \nLiên hệ để được hỗ trợ");
      }
    });
  };

  return {
    data: user,
    control,
    handleSubmit: handleSubmit(handleAddKnb),
  };
};
